import ReactDOM from "react-dom";
import { useState } from 'react'
import { useSelector } from 'react-redux'

import Card from '../../../../common/Card'
import PannelBody from '../../../../fragments/PannelBody'
import PannelHeader from '../../../../fragments/PannelHeader'
import Subtitle from '../../../../fragments/Subtitle'
import Grid from '../../../../fragments/Grid'
import { caseTypeOptions, caseSourcesOptions, stateOptions, frontendOptions, getCaseLevelOptions } from '../../../../../lib/systemData'
import CaseDetailsManagingAttorney from './CaseDetailsManagingAttorney'
import { formatDateLocal, getDaysSince } from '../../../../../lib/script'
import CaseDetailsInsuranceTagV2 from './CaseDetailsInsuranceTagV2'
import PayerTypes from './PayerTypes'
import DefaultUpdater from '../../../../common/DefaultUpdater'
import { searchTabInCaseType } from '../../../../../lib/misc'
import { useUserTabEditPermissionDisabled } from '../../../../../lib/usersPermissions'
import BodySimpleModalV3 from '../../../../common/modal/BodySimpleModalV3'
import { getCaseSourceFullNameFromId } from '../../../../../lib/labels'
import Backdrop from "../../../../common/modal/Backdrop";
import Modal from "../../../../common/Modal";
import ModalInnerWrapper from "../../../../common/ModalInnerWrapper";
import Button from "../../../../common/Button";
import classes from './CaseDetails.module.css'
import { parseApiDateOrDateTime } from "../../../../../lib/dateParsing";


const CaseDetails = () => {
    let userPermissionMasterStatusEdit = useUserTabEditPermissionDisabled('case_master_status_edit')
    const [showModal, setShowModal] = useState(false)
    const activeCase = useSelector(state => state.case.activeCase)

    const lastPracticeFinalTreatmentDate = (() => {
        const practices = Array.isArray(activeCase?.practices) ? activeCase.practices : []
        let latest = null
        for (const p of practices) {
            const raw = p?.final_treatment
            if (!raw) continue
            const d = parseApiDateOrDateTime(raw)
            if (!d) continue
            if (!latest || d > latest) latest = d
        }
        return latest ? formatDateLocal(latest) : null
    })()

    const gdqExitDate =
        activeCase?.work_queue_gdq_mrq?.gdq_exit_date ??
        activeCase?.gdq_mrq?.gdq_exit_date ??
        null

    const lastFinalTreatmentDisplay =
        lastPracticeFinalTreatmentDate ||
        (gdqExitDate ? formatDateLocal(gdqExitDate) : null)

    function showModalOnChangeHandler(data) {
        setShowModal(true)
    }

    function closeModalHandler(data) {        
        setShowModal(false)
    }

    const hasSystemPayerMismatch = Boolean(activeCase?.case?.case_payer_type_status_mismatch)
        
    return <>
        <Card>
            {activeCase && <>
                {!!activeCase?.case?.is_discharged && (
                    <div className={classes.discharged_alert}>
                        <strong>
                            Discharged
                            {lastFinalTreatmentDisplay && <> on {lastFinalTreatmentDisplay}</>}
                        </strong>
                   
                    </div>
                )}
                <PannelHeader>
                    <div className='flex-vertical-center'>
                        <div>
                            <h2>Case details</h2>
                            <Subtitle>{getDaysSince(activeCase.case.initial_treatment)} days treating</Subtitle>
                        </div>               
                        <DefaultUpdater type={'select'} value={activeCase?.case?.master_status_id} options={frontendOptions()?.MASTER_STATUS} label={'Master Status'} identifier={{type: 'case', field: 'master_status_id', folder: 'case'}} extraOptions={{isDisabled: userPermissionMasterStatusEdit, changeArchivedUnarchive: true}}/>
                    </div>               

                    
                </PannelHeader>

                <PannelBody background={hasSystemPayerMismatch ? 'var(--red-transparent)' : undefined}>
                    <PayerTypes />
                </PannelBody>
                
                <PannelBody>
                    <Grid columns={3} gap={8} special={'case_sidebar'}>
                        <DefaultUpdater type={'date'} value={activeCase?.case?.initial_treatment} label={'Initial Treatment'} identifier={{type: 'case', field: 'initial_treatment', folder: 'case'}}/>

                        <DefaultUpdater type={'select'} value={activeCase?.case?.case_level_id} options={getCaseLevelOptions()} label={'Case Level'} identifier={{type: 'case', field: 'case_level_id', folder: 'case'}}/>

                        <DefaultUpdater type={'select'} value={activeCase?.case?.case_type_id} options={caseTypeOptions()} label={'Case Type'} identifier={{type: 'case', field: 'case_type_id', folder: 'case'}} extraOptions={{rtlDrawer: true, borderRed: !activeCase?.case?.case_type_id}} />

                        <DefaultUpdater type={'date'} value={activeCase?.case?.incident_date} label={'Date of Incident'} identifier={{type: 'case', field: 'incident_date', folder: 'case'}} extraOptions={{nofuture: true, borderRed: !activeCase?.case?.incident_date}} extraAction={showModalOnChangeHandler}/>

                        <DefaultUpdater type={'select'} value={activeCase?.case?.state} options={stateOptions()} label={'State of incident'} identifier={{type: 'case', field: 'state', folder: 'case'}} extraOptions={{borderRed: !activeCase?.case?.state}} extraAction={showModalOnChangeHandler}/>

                        <BodySimpleModalV3 normalEvent={true} message={getCaseSourceFullNameFromId(activeCase?.case?.case_source_id)} disabled={!getCaseSourceFullNameFromId(activeCase?.case?.case_source_id)}>
                            <DefaultUpdater type={'select'} value={activeCase?.case?.case_source_id} options={caseSourcesOptions()} label={'Source'} identifier={{type: 'case', field: 'case_source_id', folder: 'case'}} extraOptions={{rtlDrawer: true}} extraAction={showModalOnChangeHandler}/>
                        </BodySimpleModalV3>
                    </Grid>

                    {searchTabInCaseType(activeCase, "liability") && <CaseDetailsInsuranceTagV2 />}
                    
                    
                </PannelBody>
                
                <CaseDetailsManagingAttorney />
            </>}
            
        </Card>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler}  modalTitle={'For Your Information'}>
                        <PannelBody>
                            <p>This information is also available in Nextgen, but it does not sync automatically.</p>
                            <p><strong>Please update the value in Nextgen as well.</strong></p>
                           
                        </PannelBody>
                        <PannelBody>
                            <div className="flex-container">
                                <Button click={closeModalHandler}>Ok</Button>
                            </div>
                        </PannelBody>
                    </ModalInnerWrapper>    
                </Modal>,
                document.getElementById("overlay-root")
            )}  
            
        </>}
    </>
}

export default CaseDetails